import {Component, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {CompanyRouteContextService} from '@services/company-route-context.service';
import {CompanyService} from '@services/company.service';
import {ICompanyRibFile} from '@models/workspace.interface';
import {DatePipe} from '@angular/common';
import {NotificationService} from '@services/frontend/notification.service';
import {httpErrorMessage} from 'app/utils/http-error.utils';

@Component({
  selector: 'app-company-rib',
  imports: [DatePipe],
  templateUrl: './company-rib.html'
})
export class CompanyRib implements OnInit {
  private readonly routeContext = inject(CompanyRouteContextService);
  private readonly companyService = inject(CompanyService);
  private readonly notificationService = inject(NotificationService);

  loading: WritableSignal<boolean> = signal(false);
  files: WritableSignal<ICompanyRibFile[]> = signal([]);

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    const siret = this.routeContext.currentSiret();
    if (!siret) return;
    this.loading.set(true);
    this.companyService.getRibFiles(siret).subscribe({
      next: (response) => {
        this.files.set(response);
        this.loading.set(false);
      },
      error: () => this.loading.set(false),
    });
  }

  upload(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    const siret = this.routeContext.currentSiret();
    if (!file || !siret) return;
    this.companyService.uploadUserFile(siret, file).subscribe({
      next: () => {
        this.notificationService.success('RIB ajoute', 2000);
        input.value = '';
        this.load();
      },
      error: (err) => this.notificationService.error(
        httpErrorMessage(err, 'Erreur pendant l’upload du RIB'),
        5000
      ),
    });
  }

  download(fileId: string): void {
    const siret = this.routeContext.currentSiret();
    if (!siret) return;
    this.companyService.downloadUserFile(siret, fileId).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'rib';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: () => this.notificationService.error('Erreur pendant le telechargement', 2000),
    });
  }
}
